import { Injectable } from '@angular/core';
import { AutoKeyDetailsListViewModel, AutoKeyViewModel, WorkOrderDetails, LockerDetail, ShareBoxLogFinalViewModel, AppointmentDetailByDealerIdViewModel } from '../business-entities/auto-key-model';
import { BrandViewModel } from '../business-entities/brand-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { AutoKeyDataService } from '../data-services/auto-key-data.service';

@Injectable({
    providedIn: 'root'
})

export class AutoKeyBusinessService {
    brandList: BrandViewModel[];
    autoKeyDetails: AutoKeyViewModel;
    dealerId: string;
    isEdit: boolean =false;
    appointmentId: number;
    autoKeyId : number;
    selectedDealer:string='';
    dealerList: Array<SelectListItemViewModel>;

    constructor(private service: AutoKeyDataService) { }
    async getAutoKeyDetailsByDealer(dealerId:string) {
        let autoKetDetailsList: AutoKeyDetailsListViewModel;
        await this.service
            .getAutoKeyDetailsByDealer(dealerId)
            .then(
                (res: GenericResponse<AutoKeyDetailsListViewModel>) => {
                    autoKetDetailsList = res.responseObject;
                }
            );
        return autoKetDetailsList;
    }

    async GetActiveReservationList(dealerId:string) {
        let activeReservationList: any;
        await this.service
            .GetActiveReservationList(dealerId)
            .then(
                (res: GenericResponse<any>) => { 
                    activeReservationList = res.responseObject;
                }
            );
        return activeReservationList;
    }
    getWorkOrderDetails(model:any): Promise<GenericResponse<Array<WorkOrderDetails>>>{
        return this.service.getWorkOrderDetails(model);
    }

    reserveLocker(model : any) : Promise<GenericResponse<boolean>>{
        return this.service.reserveLocker(model);
    }

    unlockKeyLocker(autoKeyId : number,applicationId: number): Promise<GenericResponse<any>> {
        return this.service.unlockKeyLocker(autoKeyId,applicationId);
    }

    getAvailableLockers(dealerId: string): Promise<GenericResponse<Array<LockerDetail>>> {
        return this.service.getAvailableLockers(dealerId);
    }

    openLocker(autoKeyId : number,applicationId: number) : Promise<GenericResponse<any>>{
        return this.service.openLocker(autoKeyId,applicationId);
    }

    async getAppointmentAutoKeyDetail(autoKeyId : number){
        let response: AutoKeyViewModel;
        await this.service
            .getAppointmentAutoKeyDetail(autoKeyId)
            .then(
                (res: GenericResponse<AutoKeyViewModel>) => {
                    response = res.responseObject;
                }
            );
        return response;
    }

    async getShareboxLogData(appointmentId:Number) {
        let shareboxLogData: ShareBoxLogFinalViewModel;
        await this.service
            .getShareboxLogData(appointmentId)
            .then(
                (res: GenericResponse<ShareBoxLogFinalViewModel>) => {
                    shareboxLogData = res.responseObject;
                }
            );
        return shareboxLogData;
    }
     
    async GetAppointmentByDealerIdAndAppointmentId(dealerId: string, appointmentId:number){
        let data: AppointmentDetailByDealerIdViewModel[] = [];
        await this.service.GetAppointmentByDealerIdAndAppointmentId(dealerId, appointmentId).then(
            (res: GenericResponse<AppointmentDetailByDealerIdViewModel[]>) => {
                data = res.responseObject;
            }
        )
        return data;
    }

    async AssignLockerToOrder(model: any) : Promise<GenericResponse<boolean>>{
        return await this.service.AssignLockerToOrder(model);
    }

    // editDealerServices(dealerServiceViewModel: DealerServiceViewModel): Promise<GenericResponse<DealerServiceViewModel>> {
    //     return this.dealerServiceDataService.editDealerServices(dealerServiceViewModel);
    // }

    // deleteDealerService(id: number) {
    //     return this.dealerServiceDataService.deleteDealerService(id);
    // }

    // getServiceCategory() {
    //     return this.dealerServiceDataService.getServiceCategory();
    // }
}
